<template>
  <section class="section-downloadApp">
    <div class="container">
      <div class="row pt-5 pt-lg-0">
        <div
          class="col-12 col-sm-12 col-md-5 align-self-center text-center text-md-left"
        >
          <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 align-self-center text-center text-md-left"> -->
          <h5 class="mob-fs-20">Book your seats on the Go!</h5>
          <p class="mob-fs-16">
            Download the App and book tickets to your
            <br />favorite films whenever, where ever!
          </p>

          <div class="app-links text-center py-3 py-md-0">
            <!-- <a href>
              <img
                src="@/assets/img/download-playStore.svg"
                class="img-fluid d-none d-md-block"
              />
              <img
                src="@/assets/img/download-playStore-mobile.svg"
                class="img-fluid d-md-none"
              />
            </a>
            <a href>
              <img
                src="@/assets/img/download-appStore.svg"
                class="img-fluid d-none d-md-block"
              />
              <img
                src="@/assets/img/download-appStore-mobile.svg"
                class="img-fluid d-md-none"
              />
            </a> -->
            <a
              href="https://play.google.com/store/apps/details?id=io.enpointe.miraj_cinema"
              target="balnk"
            >
              <img
                src="@/assets/img/GooglePlay.png"
                class="img-fluid d-none d-md-block"
              />
            </a>
            <a
              href="https://apps.apple.com/in/app/miraj-cinemas/id1668970498"
              target="balnk"
            >
              <img
                src="@/assets/img/AppStore.png"
                class="img-fluid d-none d-md-block"
              />
            </a>
          </div>
        </div>

        <!-- UNCOMMENT ALL AFTER REPLACING IMAGE WITH TRANSPARENT BACKGROUND -->
        <!-- <div class="col-12 col-sm-12 col-md-2 align-self-center text-center d-none d-md-block">
          <img src="@/assets/img/gif/Mascots-babycorn.gif" class="img-fluid" alt />
        </div> -->

        <div class="col-12 col-sm-12 col-md-5 ml-auto">
          <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 text-center text-md-right"> -->
          <img
            src="@/assets/img/fopter-image.png"
            class="ml-auto img-fluid d-none d-md-block"
            alt
          />
          <img
            src="@/assets/img/donwloadAppMobile.png"
            class="img-fluid d-md-none"
            alt
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  },
  beforeMount() {},
  components: {},
  computed: {},
  methods: {},
};
</script>
<style>
.section-downloadApp {
  background-color: var(--bg-dark-2);
}

.section-downloadApp h5 {
  font-weight: bold;
  font-size: 30px;
}

.section-downloadApp p {
  font-size: 18px;
  font-weight: 300;
}

.section-downloadApp .app-links {
  margin-left: -15px;
  display: flex;
}
/* .sm-img {
  width: 60%;
  margin-left: auto;
} */
@media (max-width: 767px) {
  .section-downloadApp .app-links {
    margin-left: 0px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/downloadApp.vue